export default "__VITE_ASSET__b610bf8a__"